<template>
  <div>
    <a class=" liFontSmallBlack" data-toggle="collapse" :href="'#' + id">
      {{ $t(headline) }}
    </a>

    <div :id="id" :class="getClassName" data-parent="#accordion">
      <div
        v-for="(element, index) in dropDownElements"
        :key="element.productNr"
      >
        <hr v-if="index != 0" class="instrumentsAndAccessoiresMenuSeperator" />
        <div class="row">
          <div class="col-3 text-left liFontSmallBold">
            {{ element.productNr }}
          </div>
          <div class="col-9 text-left liFontSmallLight">
            {{ $t(element.productInfo) }}
          </div>
        </div>
      </div>
    </div>
    <hr class="instrumentsAndAccessoiresMenuSeperator" />
  </div>
</template>

<script>
export default {
  name: "CollapseIndex",
  props: {
    headline: String,
    dropDownElements: Array,
    id: String,
    className: String
  },
  computed: {
    getClassName() {
      return this.id == "collapseOne"
        ? "collapse show dropDownElementWrapper"
        : "collapse dropDownElementWrapper";
    }
  }
};
</script>

<style scoped>
.collapse {
  margin-top: 20px;
}
.dropDownElementWrapper {
  margin-top: 20px;
}
</style>
